<template>
  <transition name="modal-fade">
    <div v-if="internalShow" class="stop-campaign-modal-overlay">
      <div class="stop-campaign-modal-container">
        <div class="stop-campaign-modal-content">
          <!-- Header -->
          <div class="stop-campaign-modal-header">
            <p class="stop-campaign-modal-title">How would you like to stop this campaign?</p>
          </div>

          <!-- Body -->
          <div class="stop-campaign-modal-body">
            <p class="stop-campaign-description">Choose when to stop this campaign:</p>
            
            <div class="stop-campaign-options">
              <div class="stop-campaign-option">
                <strong>Stop Now :</strong> Campaign will be stopped immediately and will no longer receive data.
              </div>
              <div class="stop-campaign-option">
                <strong>Stop After Current Period :</strong> Campaign will continue to receive data until the end of current billing period (1 month from payment date).
              </div>
            </div>
          </div>

          <!-- Footer / Actions -->
          <div class="stop-campaign-modal-footer">
            <button 
              class="btn-stop-now" 
              @click="handleStopNow"
              :disabled="internalIsLoading"
            >
              <span v-if="!internalIsLoading">Stop Now</span>
              <span v-else><i class="fas fa-spinner fa-spin"></i> Processing...</span>
            </button>
            <button 
              class="btn-stop-after" 
              @click="handleStopAfter"
              :disabled="internalIsLoading"
            >
              Stop After Current Period
            </button>
            <button 
              class="btn-cancel" 
              @click="handleCancel"
              :disabled="internalIsLoading"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'StopCampaignModal',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      internalShow: this.show,
      internalIsLoading: false
    };
  },
  watch: {
    show(newVal) {
      this.internalShow = newVal;
    }
  },
  methods: {
    handleStopNow() {
      if (this.internalIsLoading) return;
      this.$emit('stop-now');
    },
    handleStopAfter() {
      if (this.internalIsLoading) return;
      this.$emit('stop-after');
    },
    handleCancel() {
      if (this.internalIsLoading) return;
      this.$emit('cancel');
    }
  }
};
</script>

<style scoped>
/* Modal Overlay */
.stop-campaign-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  overflow: auto;
  padding: 20px;
}

/* Modal Container */
.stop-campaign-modal-container {
  width: 100%;
  max-width: 600px;
  margin: auto;
}

/* Modal Content */
.stop-campaign-modal-content {
  background: white;
  border-radius: 10px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  animation: modalSlideIn 0.3s ease-out;
}

/* Header */
.stop-campaign-modal-header {
    padding: 24px 28px 16px;
    border-bottom: 1px solid #e5e7eb;
}

.stop-campaign-modal-title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  text-align: center;
}

/* Body */
.stop-campaign-modal-body {
  padding: 24px 28px;
}

.stop-campaign-description {
  margin: 0 0 16px 0;
  color: #222222;
  font-size: 14px;
  font-weight: 500;
}

.stop-campaign-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
}

.stop-campaign-option {
  padding: 12px 14px;
  background: #f7f8f9;
  border-radius: 6px;
  color: #222222;
  font-size: 14px;
  line-height: 1.5;
}

.stop-campaign-option strong {
  color: #111827;
}

/* Footer */
.stop-campaign-modal-footer {
  padding: 20px 28px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}

.stop-campaign-modal-footer button {
  padding: 10px 24px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 140px;
}

.stop-campaign-modal-footer button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-stop-now {
  background-color: #dc3545;
  color: white;
}

.btn-stop-now:hover:not(:disabled) {
  background-color: #c82333;
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
}

.btn-stop-after {
  background-color: #ffc107;
  color: #333;
}

.btn-stop-after:hover:not(:disabled) {
  background-color: #ffb300;
  box-shadow: 0 4px 12px rgba(255, 193, 7, 0.3);
}

.btn-cancel {
  background-color: #6c757d;
  color: white;
}

.btn-cancel:hover:not(:disabled) {
  background-color: #5a6268;
  box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
}

/* Animations */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

@keyframes modalSlideIn {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Responsive */
@media (max-width: 640px) {
  .stop-campaign-modal-content {
    margin: 0;
  }

  .stop-campaign-modal-footer {
    flex-direction: column;
  }

  .stop-campaign-modal-footer button {
    width: 100%;
  }
}
</style>
